import { METHOD } from '../utils/Constant';
import { URL } from '../utils/Config';
import { getApiClient, getFullAuthHeaders } from './base';
export const getLeadTypeDropValues = (params: any) => {
  return getApiClient(getFullAuthHeaders())({
    method: METHOD.GET,
    url: URL.LEAD_TYPE_DROP,
    params,
  });
};
export const getLeadTypeProductValues = () => {
  return getApiClient(getFullAuthHeaders())({
    method: METHOD.GET,
    url: URL.LEAD_TYPE_PRODUCTS,
  });
};
export const getLeadTypeBankValues = () => {
  return getApiClient(getFullAuthHeaders())({
    method: METHOD.GET,
    url: URL.LEAD_TYPE_BANK,
  });
};
export const getLeadTypeDropdownValues = () => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.LEAD_API_URL
  )({
    method: METHOD.GET,
    url: URL.LEAD_TYPE_DROPDOWN,
  });
};
export const getLeadTypeBranchValues = (params: any) => {
  return getApiClient(getFullAuthHeaders())({
    method: METHOD.GET,
    url: URL.LEAD_TYPE_BRANCH,
    params,
  });
};
export const getTasksNameDrops = () => {
  return getApiClient(getFullAuthHeaders())({
    method: METHOD.GET,
    url: URL.TASK_NAME_DROPS,
  });
};
export const getRolesForCustomTask = () => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.TASK_API_URL
  )({
    method: METHOD.GET,
    url: URL.ROLES_CUSTOM_DROPS,
  });
};

export const getEmployeeDrop = () => {
  return getApiClient(getFullAuthHeaders())({
    method: METHOD.GET,
    url: URL.EMPLOYEE_NAME_DROPS,
  });
};
export const getStatusDrop = (params: any) => {
  return getApiClient(getFullAuthHeaders())({
    method: METHOD.GET,
    url: URL.STATUS_DROPS,
    params,
  });
};

export const getTargetsDropValues = (params: any) => {
  return getApiClient(getFullAuthHeaders())({
    method: METHOD.GET,
    url: URL.TARGET_DROP,
    params,
  });
};

export const getZonesDropValues = (params: any) => {
  return getApiClient(getFullAuthHeaders())({
    method: METHOD.GET,
    url: URL.ZONES_DROP,
    params,
  });
};

export const getPincodeDropValues = (params: any) => {
  return getApiClient(getFullAuthHeaders())({
    method: METHOD.GET,
    url: URL.PINCODE_DROP,
    params,
  });
};

export const getVillageDropValues = (params: any) => {
  return getApiClient(getFullAuthHeaders())({
    method: METHOD.GET,
    url: URL.VILLAGE_DROP,
    params,
  });
};
export const getVillageGridDropValues = (data: any) => {
  return getApiClient(getFullAuthHeaders())({
    method: METHOD.POST,
    url: URL.VILLAGE_PINCODE_GRIDS,
    data,
  });
};

export const getLeavesTypesDrops = () => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.LEAVE_API_URL
  )({
    method: METHOD.GET,
    url: URL.LEAVE_TYPE_DROP,
  });
};
export const getRoles = (params: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.BASE_API_URL
  )({
    method: METHOD.GET,
    url: URL.ROLES_DROP,
    params,
  });
};
export const getAllRolesDrops = (params: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.BASE_API_URL
  )({
    method: METHOD.GET,
    url: URL.ALL_ROLES_DROP,
    params,
  });
};
export const getMasterTargetsDropValues = () => {
  return getApiClient(getFullAuthHeaders())({
    method: METHOD.GET,
    url: URL.MASTER_GET_TARGETS,
  });
};

export const getIECTaskTypes = () => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.TASK_API_URL
  )({
    method: METHOD.POST,
    url: URL.IEC_TASK_TYPE,
  });
};
